import { Provider } from "react-redux";
import React from "react";
import { Middleware, Store, Reducer } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { isLocalDev } from "../utils/env";

interface ReduxProviderProps {
  middlewares: Array<Middleware>;
  reducer: Reducer;
  initialState: any;
}

export default class ReduxProvider extends React.Component<ReduxProviderProps> {
  static defaultProps = {
    middlewares: [],
    reducer: (state) => state,
    initialState: {},
  };

  store: Store;

  constructor(props) {
    super(props);
    this.store = configureStore({
      reducer: this.props.reducer,
      middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware().concat(this.props.middlewares);
      },
      devTools: isLocalDev(),
      preloadedState: this.props.initialState,
    });
  }

  render() {
    return <Provider store={this.store}>{this.props.children}</Provider>;
  }
}
